import {
   API
} from '.'
import {
   get,
   set
} from 'lodash';
import axios from 'axios';
import qs from 'qs';

let alertMapper = source => {
   return alert => {
      let timestamp = get(alert, `metadata.${source}Time`)
      set(alert, 'metadata.timestamp', new Date(timestamp))
      set(alert, 'metadata.source', source);
      return alert;
   };
};

export default {
   get: (dateRange) => {
      return API.get("alerts", {
         params: {
            start: dateRange[0].toISOString(),
            end: dateRange[1].toISOString()
         }
      }).then(res => {
         return []
            .concat(get(res, 'data.detection', []).map(alertMapper('detection')))
            .concat(get(res, 'data.confirmation', []).map(alertMapper('confirmation')))
            .reverse()
      })
      // .then(alerts => {
      //   return Promise.all(alerts.map(alert => axios.get(alert.geoJsonUrl)))
      //     .then(geojsons => {
      //       alerts.forEach((alert, index) => {
      //         set(alert, 'geojson', geojsons[index].data)
      //       })
      //       return alerts
      //     })
      // })
   }
}


// WEBPACK FOOTER //
// ./src/api/alerts.js